import React, { Component } from 'react'
import { connect } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { css } from 'glamor'
import {Decimal} from 'decimal.js';

import {MoveMenu} from "@learningblocks/storybook-components/lib/ProtocolComponents/MoveMenu"

import Notebook from '../notebook/Notebook'
import SceneBuilder from './SceneBuilder'
import Modal from '../modal/Modal'
import Toast from '../toast/Toast'
import {TaskTracker} from '../notebook/protocolView/TaskTracker'

import { start, drag, end, getTarget, updateScale, calculatePosition, teleport } from '../../lib/hotspot'
import { mapDataToTasks } from '../../lib/TaskDataImporter'

import sendxAPI from '../../xAPI'
import { throttle } from "lodash"

import { withTranslation } from 'react-i18next'

import {
  setTargetList,
  setLastDrop,
  pushInteractions,
  setHeldObject,
  setHeld,
  setTaskPages,
  createSolution,
  setSolution,
  createBlotPaper,
  setSceneScale,
  setModal,
  showModal,
  setToastFired,
  undo,
  setLang,
  setTaskCompleted,
  showMoveMenu
} from '../../actions';

import { Zoom } from "@learningblocks/storybook-components/lib/ProtocolComponents/Zoom";
import UndoAttempt from "./img/undo-icon-active.svg";
import UndoAttemptUsed from "./img/undo-icon-disabled.svg";

import './Scene.scss';
import colors from 'styles/_exports.module.scss';
import {Log, LogEvent} from '@learningblocks/shared-components/lib/EventLogger'; 

const DIMENSIONS = {
  width: 1515,
  height: 900,
};

class Scene extends Component {
  constructor(props) {
    super(props)

    this.state = {
      userScale: 1,
      sceneScale: 1,
      value: 0,
    }
    const interactions = (heldObj, target) => {
      //Sets target of last drop for Pipette extraction/deposit
      this.props.setLastDrop({
        lastHeld: heldObj,
        lastTarget: target
      })
    }

    this.props.pushInteractions([interactions])

    //Getting Notebook data, converting to Tasks, storing in Redux store
    const taskPages = mapDataToTasks(this.props.level)
    this.props.setTaskPages(taskPages)
  }

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      const upperIndex = Math.floor(index / 25);
      const delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  getObjectFromId = (id) => {
    if (id === undefined || id === null) {
      return null
    }
    const idArr = id.split("_")
    const obj = {
      type: "",
      id: -1,
      subId: -1,
      solution: "",
      tipType: ""
    }
    switch (idArr[0]) {
      case "P20":
      case "P100":
      case "P200":
      case "P1000":
        obj.type = "Pipette"
        obj.id = idArr[1]
        break;
      case "Solution":
        obj.type = "Solution"
        obj.id = idArr[1]
        obj.solution = this.props.solutions[obj.id - 1].type
        break;
      case "BlottingPaper":
        obj.type = "BlottingPaper"
        obj.id = idArr[1]
        obj.subId = idArr[2]
        break;
      case "Trash":
        obj.type = "Trash"
        break;
      case "PipetteRack":
        obj.type = "PipetteRack"
        break;
      case "TipBox":
        obj.type = "TipBox"
        obj.id = idArr[2]
        obj.tipType = idArr[1]
        break;
      default:
        break;
    }
    obj.id = parseInt(obj.id)
    return obj
  }

  getScrollbarHeight = () => {
    return window.innerHeight - document.getElementById("scene").offsetHeight;
  }

  handleResize = () => {
    this.setState({
      sceneScale:
        (new Decimal(window.innerHeight).minus(this.getScrollbarHeight())).dividedBy(DIMENSIONS.height).times(this.state.userScale).toNumber()
    }, () => updateScale(new Decimal(this.state.sceneScale).times(this.state.userScale).toNumber()));
  };

  // We need to attach a window event listener once the component is loaded in the DOM
  componentDidMount() {

    // xAPI content loaded
    sendxAPI({
      verb: "http://adlnet.gov/expapi/verbs/attempted",
      context: "Lab 1.4"
    })

    // Resize the scene and attach the resize method to the window resize event
    window.addEventListener("resize", this.handleResize)
    this.handleResize();

    this.props.setModal({
      display: false,
      type: "LEVEL_CHOICE",
      size: 'levelSelector',
      connect: -1
    })
    // Display the level choice modal
    this.props.showModal({display: true})

    // Get all of the available drag and drop target zones
    const temp = document.getElementsByClassName("dropTarget")
    // Push to redux
    this.props.setTargetList(temp)

    //Setting sim lang from URL param via Router prop
    this.props.setLang({
      lang: this.props.lang
    })
  }

  onDragStart = (e) => {

    let dragImage = document.getElementById('dragImage')

    if(dragImage == null){

      dragImage = document.createElement('img')
      dragImage.id = "dragImage"
      dragImage.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg=="
      document.body.appendChild(dragImage);
    }

    const testVar = window.DataTransfer || window.Clipboard;  // Clipboard is for Chrome
    if("setDragImage" in testVar.prototype) {
        e.dataTransfer.setDragImage(dragImage, 0, 0)
    }
    if("setData" in testVar.prototype){
        e.dataTransfer.setData('text/plain', '');
    }

    //Delete when working
    const temp = document.getElementsByClassName("dropTarget")
    this.props.setTargetList(temp)

    //Checks if pipette and not a tipbox
    if (e.target.id.includes("P") && !e.target.id.includes("TipBox")) {
      //Get ID of pipette from HTML ID
      const tempId = parseInt(e.target.id.split("_")[1])

      //Set held object in redux to this data:
      this.props.setHeldObject({
        type: "Pipette",
        id: tempId,
        htmlObj: e.target,
      })
      //Change pipette's state to held = true
      this.props.setHeld({
        id: tempId,
        held: true,
      })
    }

    //Checks if is a tipbox
    if (e.target.id.includes("P") && e.target.id.includes("TipBox")) {
      //Get ID of pipette from HTML ID
      const tempId = parseInt(e.target.id.split("_")[1])

      //Set held object in redux to this data:
      this.props.setHeldObject({
        type: "TipBox",
        id: tempId,
        htmlObj: e.target,
      })
    }
    start(e, e.target)
  }

  onDragOver = throttle((e) => {
    e.preventDefault();
    drag(e);
  }, 10);

  //Check heldObj to {obj: pipette, id: ID}
  //Set held to false in target pipette
  //Set heldObj to null
  onDrop = (e) => {

    e.preventDefault()
    e.stopPropagation()

    if (this.props.heldObject.type === "Pipette") {
      //Change pipette's state to held = false
      this.props.setHeld({
        id: this.props.heldObject.id,
        held: false,
      });

      //Clear held object
      this.props.setHeldObject({
        type: null,
        id: -1,
        htmlObj: null,
      })
    }
    end(e)
  }

  //Runs all interaction functions that have been added to the global array
  runInteractions = (heldObj) => {
    const target = getTarget(heldObj.htmlObj, this.props.targetList).id
    this.props.interactions.forEach(interaction => {
      interaction(heldObj, this.getObjectFromId(target))
    });

    //interaction function structure
    //always takes 'target' arg -> what the component will be interacting with
    //function must internally get access to all states it needs
  }

  handleChange = (e) => {
    this.setState({value: e.target.value});
  }

  handleSubmit = (e) => {
    e.preventDefault()
    //Sanitize input
    const val = +this.state.value
    if(val <= 0 || val > 1){
      return null
    }

    //Save scale state:
    this.props.setSceneScale({
      scale: val
    })
  }

  makeToast = (type, msg, title) => {
    let color = ""
    if(type==="HINT"){
      color = colors.yellow1
    } else {
      color = colors.red1
    }

    toast(<Toast type={type} msg={msg} title={title} />,{
      className: css({
        border: "2px solid "+color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000,
    });
  }

  checkTaskForHint = () => {
    let hints = []
    //check if hint in level
    if(Object.hasOwn(this.props.focusedTask.levels['l'+this.props.level], "hints")){
      hints = this.props.focusedTask.levels['l'+this.props.level].hints
    } else {
      return null
    }
    //Create hint toast for each hint
    hints.forEach(hint => {
      if(!hint.fired){
        this.makeToast(hint.type, hint.msg, hint.title)
        this.props.setToastFired()
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {

    if(this.props.heldObject.htmlObj == null && prevProps.heldObject.type != null){
      this.runInteractions(prevProps.heldObject)
    }

    if(prevProps.notebookSection !== this.props.notebookSection && this.props.notebookSection === "Protocol"){
      this.handleResize()
    }

    if(
      this.state.userScale !== prevState.userScale
    ){
      this.handleResize();
    }

    if(this.props.scale !== prevProps.scale){
      this.handleResize();
    }

    if(this.props.notebookExpanded !== prevProps.notebookExpanded){
       this.handleResize();
    }

    //Generate new tasks if user changes level
    if(this.props.level !== prevProps.level){
      //Getting Notebook data, converting to Tasks, storing in Redux store
      const taskPages = mapDataToTasks(this.props.level)
      this.props.setTaskPages(taskPages)
    }

    //Only show hints when in Protocol
    if(this.props.notebookSection === "Protocol"){
      //Show next hint on switch to protocol
      if (this.props.notebookSection !== prevProps.notebookSection){
        this.checkTaskForHint()
      }
      //If on same page
      else if (this.props.taskIndex !== prevProps.taskIndex && this.props.taskIndex > prevProps.taskIndex){
        this.checkTaskForHint()
      }
      //If on next page
      else if (this.props.taskPage !== prevProps.taskPage && this.props.taskPage === this.props.focusedPage+1){
        this.checkTaskForHint()
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  undoClicked = () => {
   this.props.setModal({
     display: true,
     type: "UNDO",
     size: "xs",
     connect: -1
   });
  }

  restartSim = () =>{
   window.location.reload();
  }

  renderUndoBtn = () => {
   const attempts = []

   for (let i = 0; i < ((this.props.undoAttempts > 3)?3:this.props.undoAttempts); i++) {
     //Add attemps left image
     attempts.push(<img alt="Available undo icon" src={UndoAttempt} className="undoAttemptImg"/>)
   }
   for (let i = 0; i < ((this.props.undoAttempts > 3)?0:(3-this.props.undoAttempts)); i++) {
     //Add attempts used image
     attempts.push(<img alt="Disabled undo icon" src={UndoAttemptUsed} className="undoAttemptImg"/>)
   }

   return (
     <div id="undo" className="undoDiv" >
       <LogEvent
          logEventProps={{
            event_type: "sim_protocol_undo requested",
            event_schema: "track",
            step: this.props.taskPage + this.getAlphabetIndex(this.props.focusedTask.index),
            undo_attempt: this.props.undoAttempts
          }}
          actionProps={{ onClick: { action: 'click' } }}
          elementType="button">
          <button className="undoBtn" tabIndex="0" onClick={this.undoClicked}>
            {this.props.t("Restart step")}
          </button>
        </LogEvent>
      
       {attempts}
     </div>
   );
  };

  toggleMoveMenu = () => {
    this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };

  render() {
    return (
      <div>
        <Log
          level={this.props.level}
          section={(this.props.sectionSelected)?this.props.sectionSelected.toLowerCase():null}
        >
          <div
            className={"content"+((this.props.notebookExpanded)?" sidebar-active":"")}>
            <div style={{
              overflow: "auto",
              width: "100%",
              height: "100%",
              position: "absolute"
            }}>
              <div
                id='scene'
                style={{
                  transform: "scale(" + this.state.userScale + ")",
                  width: "100%",
                  height: "100%",
                  transformOrigin: "top left",
                  position: "absolute",
                }}>
                <div
                  id="dragdrop"
                  style={{
                    width: DIMENSIONS.width + "px",
                    height: DIMENSIONS.height + "px",
                    transform: "scale(" + this.state.sceneScale + ")",
                    transformOrigin: "top left",
                    //boxSizing: "border-box",
                    //border: "3px solid red"
                  }}
                  onDragStart={this.onDragStart}
                  onDragOver={(e)=>{e.persist();this.onDragOver(e);}}
                  onDragEnd={this.onDrop}>
                  <SceneBuilder />
                  <LogEvent
                    logEventProps={{
                      event_type: "sim_protocol_step completed",
                      event_schema: "protocolstep",
                      step_number: this.getAlphabetIndex(this.props.focusedTask.index),
                      part_number: this.props.taskPage,
                      total_steps: this.props.taskPages.reduce((count, innerArray) => count + innerArray.tasks.length, 0),
                    }}
                    actionProps={{ setTaskCompleted: { action: 'complete' } }}
                    elementType="button"
                  >
                    <TaskTracker setTaskCompleted={this.props.setTaskCompleted} />
                  </LogEvent>
                </div>
              </div>
            </div>
            {this.renderUndoBtn()}
            {/* Add back when graphics for Restart Button are ready */}
            {/* <button onClick={this.restartSim}>RESTART TEST</button> */}
            <Zoom
              scale={this.state.userScale}
              setSceneScale={(scale) =>
                this.setState({
                  userScale: scale.scale,
                })
              }
            />
            <ToastContainer closeButton={false} role={"dialog"}/>
            <Modal />
            <MoveMenu
              component={this.props.moveMenuComponent}
              type={this.props.moveMenuType}
              connect={this.props.moveMenuConnect}
              modalOpen={this.props.moveMenuDisplay}
              targetList={this.props.targetList}
              toggleModal={() => this.toggleMoveMenu()}
              lang={this.props.lang}
              notebookExpanded={this.props.notebookExpanded}
              setHeld={this.props.setHeld}
              setHeldObject={this.props.setHeldObject}
              calculatePosition={calculatePosition}
              teleport={teleport}
            />
          </div>
          <Notebook />
        </Log>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    heldObject: state.scene.heldObject,
    targetList: state.scene.targetList,
    interactions: state.scene.interactions,
    solutions: state.solution.solutions,
    blotPapers: state.blotPaper.blotPapers,
    level: state.notebook.level,
    scale: state.scene.scale,
    focusedTask: state.notebook.focusedTaskObj,
    focusedPage: state.notebook.focusedPage,
    taskIndex: state.notebook.focusedTask,
    taskPage: state.notebook.currentProtocolPage,
    taskPages: state.notebook.taskPages,
    notebookSection: state.notebook.sectionSelected,
    notebookExpanded: state.scene.notebookExpanded,
    lang: ownProps.lang,
    undoAttempts: state.undo.attempts,
    lastState: state.undo.snapshots.back1,
    sectionSelected: state.notebook.sectionSelected,
    moveMenuDisplay: state.moveMenu.display,
    moveMenuComponent: state.moveMenu.component,
    moveMenuType: state.moveMenu.type,
    moveMenuConnect: state.moveMenu.connect
  }
}

export default connect(mapStateToProps, {
  setTargetList,
  setLastDrop,
  pushInteractions,
  setHeldObject,
  setHeld,
  setTaskPages,
  createSolution,
  setSolution,
  createBlotPaper,
  setSceneScale,
  setModal,
  showModal,
  setToastFired,
  undo,
  setLang,
  setTaskCompleted,
  showMoveMenu
})(withTranslation()(Scene));
